import { Brush, Eraser, Lasso, PenTool, SquareDashed, WandSparkles } from 'lucide-react';

export enum EDIT_IMAGE_METHOD {
  STYLE = 'style',
  MAGIC = 'magic',
}

export enum MAGIC_TOOL_OPTIONS {
  BRUSH = 'brush',
  ERASER = 'eraser',
  LASSO = 'lasso',
  PEN = 'pen',
  RECTANGLE_MARQUEE = 'reactangle_marquee',
  MAGIC_WAND = 'magic_wand',
}

export const editMethodOptions = [
  {
    label: 'style',
    value: EDIT_IMAGE_METHOD.STYLE,
  },
  {
    label: 'magic',
    value: EDIT_IMAGE_METHOD.MAGIC,
  },
];

export const magicToolOptions = [
  {
    icon: Brush,
    value: MAGIC_TOOL_OPTIONS.BRUSH,
  },
  {
    icon: Eraser,
    value: MAGIC_TOOL_OPTIONS.ERASER,
  },
  {
    icon: Lasso,
    value: MAGIC_TOOL_OPTIONS.LASSO,
  },
  {
    icon: PenTool,
    value: MAGIC_TOOL_OPTIONS.PEN,
  },
  {
    icon: SquareDashed,
    value: MAGIC_TOOL_OPTIONS.RECTANGLE_MARQUEE,
  },
  {
    icon: WandSparkles,
    value: MAGIC_TOOL_OPTIONS.MAGIC_WAND,
  },
];
